var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIcnHangout = function SvgIcnHangout(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0Z",
    fill: "#283141"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.813 9.23V5.45h.8v1.56h1.622V5.45h.798v3.78h-.798V7.67H5.612V9.23h-.799ZM9.402 10.92h-1.34V7.139h1.351c.38 0 .708.076.982.227.275.15.486.366.634.648.149.282.223.62.223 1.012 0 .393-.075.732-.223 1.015-.148.283-.36.5-.637.652-.276.151-.606.227-.99.227Zm-.54-.685h.507c.236 0 .435-.042.596-.126a.808.808 0 0 0 .366-.393c.082-.178.123-.409.123-.69 0-.28-.04-.508-.123-.685a.8.8 0 0 0-.364-.392 1.283 1.283 0 0 0-.596-.125h-.51v2.41Z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.058 3.187h-.065v9.682h.065V3.187Z",
    fill: "#fff"
  })));
};
export default SvgIcnHangout;